import React from 'react';
import './About.css';

const About = () => {
  return (
    <div className="about-page">
      {/* Hero Section */}
      <section className="about-hero">
        <div className="container">
          <div className="hero-content">
            <h1>About Pathway Labs</h1>
            <p className="hero-subtitle">
              Infrastructure built to support people, not bureaucracy.
            </p>
          </div>
        </div>
      </section>

      {/* Origin Section */}
      <section className="section">
        <div className="container">
          <div className="about-block">
            <h2>Where we started</h2>
            <p className="about-text">
              Pathway Labs was created inside a larger mission: to support families, stabilize communities,
              and expand opportunities for youth.
            </p>
            <p className="about-text">
              We saw programs doing life-changing work held back by fragile tools, disconnected data,
              and constant rework. Pathway Labs exists to fix that—by giving mission-driven organizations
              the same caliber of infrastructure that high-growth companies enjoy.
            </p>
          </div>
        </div>
      </section>

      {/* Mission & Vision Section */}
      <section className="section section-alt">
        <div className="container">
          <div className="mission-vision-grid">
            <div className="mission-block">
              <h2>Mission</h2>
              <p className="about-text">
                Design and maintain the systems that allow human-centered work to scale safely,
                transparently, and sustainably.
              </p>
            </div>
            <div className="vision-block">
              <h2>Long-view vision</h2>
              <p className="about-text">
                We build with a multi-generation horizon in mind. The work you do today should be easier,
                not harder, for the teams that come after you.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Principles Section */}
      <section className="section">
        <div className="container">
          <div className="section-header">
            <h2>How we build</h2>
          </div>
          <div className="principles-grid">
            <div className="principle-card">
              <h3>Compliance first</h3>
              <p>
                We assume your work will be audited, reviewed, and questioned.
                We build systems that hold up under that pressure.
              </p>
            </div>
            <div className="principle-card">
              <h3>Evidence-driven</h3>
              <p>
                If it matters, it should be logged. We design workflows that generate
                usable, structured data—not noise.
              </p>
            </div>
            <div className="principle-card">
              <h3>Human-centered</h3>
              <p>
                Your staff, youth, and families are not edge cases. We prioritize usability,
                clarity, and respect in every interface.
              </p>
            </div>
            <div className="principle-card">
              <h3>Continuity-minded</h3>
              <p>
                We design for handoffs—between staff, leadership, and generations.
                No more starting from scratch every few years.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Ecosystem Section */}
      <section className="section ecosystem-section">
        <div className="container">
          <div className="ecosystem-content">
            <h2>The broader ecosystem</h2>
            <p className="ecosystem-text">
              Pathway Labs operates within a larger ecosystem that includes programs focused on families
              and youth, long-term capital partners, and community initiatives. Our role is to keep the
              systems stable so the people doing the work can stay focused on impact.
            </p>
          </div>
        </div>
      </section>

      {/* Team Section */}
      <section className="section section-alt">
        <div className="container">
          <div className="team-content">
            <h2>Who we work with</h2>
            <p className="team-text">
              We collaborate with program leaders, technologists, and advisors who understand both the
              realities on the ground and the demands of modern infrastructure.
            </p>
            <div className="team-placeholder">
              <p>Team profiles coming soon</p>
            </div>
          </div>
        </div>
      </section>

      {/* Disclaimers Section */}
      <section className="section disclaimers-section">
        <div className="container">
          <div className="disclaimers-content">
            <h2>Important Disclosures</h2>

            <div className="disclaimer-block">
              <h4>General Information</h4>
              <p>
                Pathway Labs provides software, digital tools, and workflow systems. All information
                on this website is for informational purposes only and does not constitute professional,
                legal, or tax advice. Organizations should consult qualified professionals before making
                decisions involving compliance, regulatory matters, or legal obligations.
              </p>
            </div>

            <div className="disclaimer-block">
              <h4>No Legal or Tax Advice</h4>
              <p>
                Pathway Labs does not provide legal, tax, accounting, or compliance advice. Any references
                to compliance workflows, reporting tools, or policy frameworks are generalized explanations
                of potential system features and do not replace professional counsel.
              </p>
            </div>

            <div className="disclaimer-block">
              <h4>Software Use</h4>
              <p>
                Use of Pathway Labs tools does not ensure compliance with any law or regulation. Organizations
                are solely responsible for ensuring the accuracy and appropriateness of the information they
                input and the regulatory requirements they must satisfy.
              </p>
            </div>

            <div className="disclaimer-block">
              <h4>Data & Privacy</h4>
              <p>
                Pathway Labs does not sell user data and maintains privacy standards aligned with modern
                SaaS practices. Actual implementation depends on your specific deployment and configuration.
              </p>
            </div>

            <div className="disclaimer-block">
              <h4>Independent Provider</h4>
              <p>
                Pathway Labs is a private software provider and is not affiliated with any government
                agency or regulatory body.
              </p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default About;
